<div class="p-2">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Statystyki aplikacji</div>
  <div class="main-card p-3 statistics-container">


  <div *ngIf="loadingSummary" class="flex justify-content-center align-items-center mb-4" style="min-height: 200px;">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loadingSummary && summaryStatistics" class="mb-4">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-3">
        <p-card styleClass="summary-card">
          <div class="text-center">
            <i class="pi pi-users text-5xl text-blue-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Wszyscy użytkownicy</h3>
            <p class="text-4xl font-bold text-blue-600">{{ summaryStatistics.totalUsersCount }}</p>
            <p class="text-sm text-gray-600 mt-2">Od początku platformy</p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-3">
        <p-card styleClass="summary-card">
          <div class="text-center">
            <i class="pi pi-user-plus text-5xl text-green-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Wszyscy aktywni użytkownicy</h3>
            <p class="text-4xl font-bold text-green-600">{{ summaryStatistics.totalActiveUsersCount }}</p>
            <p class="text-sm text-gray-600 mt-2">Od początku platformy</p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-3" *ngFor="let sub of summaryStatistics.subscriptionStatistics?.slice(0, 2); let i = index">
        <p-card styleClass="summary-card">
          <div class="text-center">
            <i class="pi pi-ticket text-5xl mb-3" 
               [ngClass]="i === 0 ? 'text-orange-500' : 'text-purple-500'"></i>
            <h3 class="text-xl font-semibold mb-2">{{ sub.subscriptionPlanName }}</h3>
            <p class="text-4xl font-bold" 
               [ngClass]="i === 0 ? 'text-orange-600' : 'text-purple-600'">
              {{ sub.count }}
            </p>
            <p class="text-sm text-gray-600 mt-2">
              {{ sub.activeCount }} aktywnych ({{ (sub.activeCount / sub.count * 100).toFixed(1) }}%)
            </p>
          </div>
        </p-card>
      </div>
    </div>

        <!-- Nowa sekcja: Dane historyczne vs bieżące -->
    <div class="grid mt-4">
      <div class="col-12">
        <h3 class="text-2xl font-semibold mb-3">
          <i class="pi pi-history mr-2"></i>
          Porównanie źródeł dostępu
        </h3>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card comparison-card">
          <div class="text-center">
            <i class="pi pi-users text-5xl text-blue-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Użytkownicy aktywni</h3>
            <div class="flex justify-content-around mt-3">
              <div>
                <p class="text-sm text-gray-600">Dzisiaj</p>
                <p class="text-3xl font-bold text-blue-600">{{ summaryStatistics!.activeUsersCount }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Wszyscy</p>
                <p class="text-3xl font-bold text-blue-400">{{ summaryStatistics!.totalActiveUsersCount }}</p>
              </div>
            </div>
            <p class="text-sm text-gray-600 mt-2">
              {{ (summaryStatistics!.activeUsersCount / summaryStatistics!.totalActiveUsersCount * 100).toFixed(1) }}% obecnie aktywnych
            </p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card comparison-card">
          <div class="text-center">
            <i class="pi pi-credit-card text-5xl text-green-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Płatne subskrypcje</h3>
            <div class="flex justify-content-around mt-3">
              <div>
                <p class="text-sm text-gray-600">Dzisiaj</p>
                <p class="text-3xl font-bold text-green-600">{{ summaryStatistics!.paidSubscriptionsCount }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Wszyscy</p>
                <p class="text-3xl font-bold text-green-400">{{ summaryStatistics!.totalPaidSubscriptionsEverCount }}</p>
              </div>
            </div>
            <p class="text-sm text-gray-600 mt-2">
              {{ (summaryStatistics!.paidSubscriptionsCount / summaryStatistics!.totalPaidSubscriptionsEverCount * 100).toFixed(1) }}% obecnie aktywnych
            </p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card comparison-card">
          <div class="text-center">
            <i class="pi pi-book text-5xl text-orange-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Dostępy z książki</h3>
            <div class="flex justify-content-around mt-3">
              <div>
                <p class="text-sm text-gray-600">Dzisiaj</p>
                <p class="text-3xl font-bold text-orange-600">{{ summaryStatistics!.bookAccessCount }}</p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Wszyscy </p>
                <p class="text-3xl font-bold text-orange-400">{{ summaryStatistics!.totalBookAccessEverCount }}</p>
              </div>
            </div>
            <p class="text-sm text-gray-600 mt-2">
              {{ (summaryStatistics!.bookAccessCount / summaryStatistics!.totalBookAccessEverCount * 100).toFixed(1) }}% obecnie aktywnych
            </p>
          </div>
        </p-card>
      </div>
    </div>

  
    <div class="grid mt-3" *ngIf="summaryStatistics.subscriptionStatistics && summaryStatistics.subscriptionStatistics.length > 2">
      <div class="col-12 md:col-6 lg:col-3" *ngFor="let sub of (summaryStatistics.subscriptionStatistics || []).slice(2)">
        <p-card styleClass="summary-card">
          <div class="text-center">
            <i class="pi pi-ticket text-5xl text-cyan-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">{{ sub.subscriptionPlanName }}</h3>
            <p class="text-4xl font-bold text-cyan-600">{{ sub.count }}</p>
            <p class="text-sm text-gray-600 mt-2">
              {{ sub.activeCount }} aktywnych ({{ (sub.activeCount / sub.count * 100).toFixed(1) }}%)
            </p>
          </div>
        </p-card>
      </div>
    </div>

    <div class="grid mt-4">
      <div class="col-12">
        <h3 class="text-2xl font-semibold mb-3">
          <i class="pi pi-dollar mr-2"></i>
          Przychody
        </h3>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card revenue-card">
          <div class="text-center">
            <i class="pi pi-dollar text-5xl text-teal-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Całkowite przychody</h3>
            <p class="text-4xl font-bold text-teal-600">{{ summaryStatistics!.totalRevenue | number:'1.2-2' }} zł</p>
            <p class="text-sm text-gray-600 mt-2">Od początku platformy</p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card revenue-card">
          <div class="text-center">
            <i class="pi pi-credit-card text-5xl text-green-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Przychody z subskrypcji</h3>
            <p class="text-4xl font-bold text-green-600">{{ summaryStatistics!.totalPaidSubscriptionsRevenue | number:'1.2-2' }} zł</p>
            <p class="text-sm text-gray-600 mt-2">
              {{ getPaidSubscriptionsRevenuePercentage().toFixed(1) }}% przychodów
            </p>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col-6 lg:col-4">
        <p-card styleClass="summary-card revenue-card">
          <div class="text-center">
            <i class="pi pi-book text-5xl text-orange-500 mb-3"></i>
            <h3 class="text-xl font-semibold mb-2">Przychody z książki</h3>
            <p class="text-4xl font-bold text-orange-600">{{ summaryStatistics!.totalBookAccessRevenue | number:'1.2-2' }} zł</p>
            <p class="text-sm text-gray-600 mt-2">
              {{ getBookAccessRevenuePercentage().toFixed(1) }}% przychodów
            </p>
          </div>
        </p-card>
      </div>
    </div>
  </div>


  <div class="mb-4">
    <p-card styleClass="mb-4">
      <ng-template pTemplate="header">
        <div class="px-3 pt-3">
          <h3 class="text-xl font-semibold m-0">Filtry danych porównawczych</h3>
        </div>
      </ng-template>
      <div class="grid">
        <div class="col-12 md:col-3">
          <label class="block mb-2 font-semibold">Data od:</label>
          <p-calendar 
            [(ngModel)]="startDate" 
            dateFormat="dd.mm.yy"
            [showIcon]="true"
            inputId="startDate"
            styleClass="w-full">
          </p-calendar>
        </div>
        
        <div class="col-12 md:col-3">
          <label class="block mb-2 font-semibold">Data do:</label>
          <p-calendar 
            [(ngModel)]="endDate" 
            dateFormat="dd.mm.yy"
            [showIcon]="true"
            inputId="endDate"
            styleClass="w-full">
          </p-calendar>
        </div>
        
        <div class="col-12 md:col-3">
          <label class="block mb-2 font-semibold">Grupowanie:</label>
          <p-dropdown 
            [(ngModel)]="selectedGrouping" 
            [options]="groupingOptions"
            optionLabel="label"
            optionValue="value"
            styleClass="w-full">
          </p-dropdown>
        </div>
        
        <div class="col-12 md:col-3 flex align-items-end filter-actions">
          <button 
            pButton 
            label="Zastosuj filtry" 
            icon="pi pi-filter"
            (click)="applyFilters()"
            class="mr-2"
            [disabled]="loadingGrowth" data-clarity-unmask="true">
          </button>
          <button 
            pButton 
            label="Resetuj" 
            icon="pi pi-refresh"
            class="p-button-outlined"
            (click)="resetFilters()"
            [disabled]="loadingGrowth" data-clarity-unmask="true">
          </button>
        </div>
      </div>
    </p-card>
  </div>


  <div *ngIf="loadingGrowth" class="flex justify-content-center align-items-center" style="min-height: 400px;">
    <p-progressSpinner></p-progressSpinner>
  </div>

 
  <div *ngIf="!loadingGrowth && growthStatistics">


    <p-tabView>
    
      <p-tabPanel header="Przyrost użytkowników" leftIcon="pi pi-chart-bar">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="bar" 
              [data]="userGrowthBarChartData" 
              [options]="barChartOptions"
              *ngIf="userGrowthBarChartData">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia liczbę <strong>nowych użytkowników</strong> w każdym okresie.
              Niebieski słupek pokazuje wszystkich nowych użytkowników, zielony - nowych użytkowników z aktywnym planem.
            </p>
          </div>
        </p-card>
      </p-tabPanel>

      <p-tabPanel header="Wzrost w czasie" leftIcon="pi pi-chart-line">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="line" 
              [data]="userGrowthLineChartData" 
              [options]="lineChartOptions"
              *ngIf="userGrowthLineChartData">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia <strong>łączną liczbę użytkowników</strong> narastająco w czasie.
              Niebieska linia pokazuje wszystkich użytkowników, zielona - użytkowników z aktywnym planem.
            </p>
          </div>
        </p-card>
      </p-tabPanel>

      <p-tabPanel header="Aktywni vs Nieaktywni" leftIcon="pi pi-chart-bar">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="bar" 
              [data]="activeUsersComparisonChartData" 
              [options]="{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: { position: 'top' },
                  title: { 
                    display: true, 
                    text: 'Porównanie użytkowników aktywnych i nieaktywnych',
                    font: { size: 16 }
                  }
                },
                scales: {
                  x: { stacked: true },
                  y: { stacked: true, beginAtZero: true }
                }
              }"
              *ngIf="activeUsersComparisonChartData">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia rozkład <strong>nowych użytkowników</strong> na aktywnych (z planem) i nieaktywnych (bez planu).
              Słupki są skumulowane, pokazując łączną liczbę nowych użytkowników w okresie.
            </p>
          </div>
        </p-card>
      </p-tabPanel>

      <p-tabPanel header="Abonamenty" leftIcon="pi pi-chart-pie" *ngIf="subscriptionPieChartData">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="pie" 
              [data]="subscriptionPieChartData" 
              [options]="pieChartOptions">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia <strong>rozkład kupionych abonamentów</strong> od początku platformy.
              Po najechaniu na segment wyświetlana jest liczba aktywnych abonamentów.
            </p>
          </div>

          <div class="mt-4">
            <h4 class="font-semibold mb-3">Szczegóły abonamentów</h4>
            <div class="grid">
              <div class="col-12 md:col-6" *ngFor="let sub of summaryStatistics?.subscriptionStatistics">
                <div class="p-3 border-round border-1 border-gray-300 mb-2">
                  <div class="flex justify-content-between align-items-center">
                    <div>
                      <p class="font-semibold text-lg">{{ sub.subscriptionPlanName }}</p>
                      <p class="text-sm text-gray-600">
                        Kupione: <strong>{{ sub.count }}</strong> | 
                        Aktywne: <strong>{{ sub.activeCount }}</strong>
                      </p>
                    </div>
                    <div class="text-right">
                      <span class="inline-flex align-items-center justify-content-center bg-green-100 text-green-800 border-round px-3 py-2">
                        <strong>{{ (sub.activeCount / sub.count * 100).toFixed(1) }}%</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabPanel>

      <!-- Nowa zakładka: Źródła dostępu - wykres kołowy -->
      <p-tabPanel header="Źródła dostępu" leftIcon="pi pi-key" *ngIf="accessSourcePieChartData">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="pie" 
              [data]="accessSourcePieChartData" 
              [options]="accessSourcePieOptions">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia <strong>porównanie źródeł dostępu</strong> użytkowników od początku platformy.
              <strong class="text-green-700">Zielony</strong> - płatne subskrypcje, 
              <strong class="text-orange-700">Pomarańczowy</strong> - dostępy z książki.
            </p>
          </div>

          <!-- Tabela porównawcza -->
          <div class="mt-4">
            <h4 class="font-semibold mb-3">Szczegółowe porównanie</h4>
            <div class="grid">
              <div class="col-12 md:col-6">
                <div class="p-4 border-round bg-green-50 border-1 border-green-300">
                  <div class="flex align-items-center mb-3">
                    <i class="pi pi-credit-card text-3xl text-green-600 mr-3"></i>
                    <div>
                      <p class="font-semibold text-lg text-green-800">Płatne subskrypcje</p>
                      <p class="text-sm text-gray-600">Użytkownicy z wykupionymi planami</p>
                    </div>
                  </div>
                  <p class="text-3xl font-bold text-green-700">{{ summaryStatistics!.paidSubscriptionsCount }}</p>
                  <div class="mt-2">
                    <div class="bg-green-200 border-round" style="height: 8px;">
                      <div class="bg-green-600 border-round h-full" 
                           [style.width.%]="getPaidSubscriptionsPercentage()"></div>
                    </div>
                    <p class="text-sm text-gray-600 mt-1">{{ getPaidSubscriptionsPercentage().toFixed(1) }}% wszystkich</p>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6">
                <div class="p-4 border-round bg-orange-50 border-1 border-orange-300">
                  <div class="flex align-items-center mb-3">
                    <i class="pi pi-book text-3xl text-orange-600 mr-3"></i>
                    <div>
                      <p class="font-semibold text-lg text-orange-800">Dostępy z książki</p>
                      <p class="text-sm text-gray-600">Użytkownicy z kodami dostępu</p>
                    </div>
                  </div>
                  <p class="text-3xl font-bold text-orange-700">{{ summaryStatistics!.bookAccessCount }}</p>
                  <div class="mt-2">
                    <div class="bg-orange-200 border-round" style="height: 8px;">
                      <div class="bg-orange-600 border-round h-full" 
                           [style.width.%]="getBookAccessPercentage()"></div>
                    </div>
                    <p class="text-sm text-gray-600 mt-1">{{ getBookAccessPercentage().toFixed(1) }}% wszystkich</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </p-tabPanel>

      <!-- Nowa zakładka: Wzrost źródeł dostępu -->
      <p-tabPanel header="Wzrost wg źródeł" leftIcon="pi pi-chart-line" *ngIf="accessSourceGrowthChartData">
        <p-card>
          <div class="chart-box">
            <p-chart 
              type="bar" 
              [data]="accessSourceGrowthChartData" 
              [options]="accessSourceGrowthOptions">
            </p-chart>
          </div>
          <div class="mt-3 p-3 bg-blue-50 border-round">
            <p class="text-sm text-gray-700">
              <i class="pi pi-info-circle mr-2"></i>
              Wykres przedstawia <strong>przyrost użytkowników według źródeł dostępu</strong> w wybranym okresie.
              Możesz porównać, które źródło dostępu było bardziej popularne w poszczególnych okresach.
            </p>
          </div>
        </p-card>
      </p-tabPanel>
    </p-tabView>

  </div>

  <div *ngIf="!loadingGrowth && !growthStatistics" class="text-center p-5">
    <i class="pi pi-chart-line text-6xl text-gray-400 mb-3"></i>
    <p class="text-xl text-gray-600">Brak danych do wyświetlenia</p>
    <p class="text-sm text-gray-500">Wybierz zakres dat i kliknij "Zastosuj filtry"</p>
  </div>
  </div>
</div>
